export default require('./assetAppLoadingAnimation.json');
